module.exports = __webpack_public_path__ + "../resources/images/like-3c5226c7b134e250b1cfa4002dfd7d4b.svg";